module.exports = __webpack_public_path__ + "img/banner-light.39f6fcea.webp";